const addHierarchicalId = (obj, pId = "", id) => {
	let newObj = { ...obj };
	newObj.id = pId;
	newObj.id += id;
	if (newObj.hasOwnProperty("menus") && newObj.menus.length) {
		newObj.menus = newObj.menus.map((obj, j) => {
			return addHierarchicalId(obj, newObj.id, j);
		});
	}
	return newObj;
};
export const initIterator = (arr, pId = "") => {
	return arr.map((item, i) => {
		return addHierarchicalId(item, pId, i);
	});
};
